export default {
  methods: {
    // var priceGroupDesc harusnya bisa dipake untuk deskripsi,
    // tapi yang sekarang banyak priceGroupDesc yang isinya malah CODE bukan DESKRIPSI
    mixinGetGroupPriceName(code) {
      let text = code
      if (code === 'FRE' || code === 'PTP') {
        text = 'Freight and Part of Freight'
      } else if (code === 'LC') {
        text = 'Local Charge'
      } else if (code === 'LCORIGIN') {
        text = 'Origin Local Charges'
      } else if (code === 'LCDESTINATION') {
        text = 'Destination Local Charges'
      } else if (code === 'REIMBURSEMENT') {
        text = 'Reimbursement'
      } else if (code === 'OTHERS') {
        text = 'Overtime'
      }
      return text
    },

    mixinGetWeightRangeObj(weight) {
      let objWeight = {
        name: '0',
        value: 0
      }
      if (parseFloat(weight) <= 45) {
        objWeight = {
          name: '< 45 Kg',
          value: 1
        }
      } else if (parseFloat(weight) > 45 && parseFloat(weight) <= 100) {
        objWeight = {
          name: '+ 45 Kg',
          value: 45
        }
      } else if (parseFloat(weight) > 100 && parseFloat(weight) <= 250) {
        objWeight = {
          name: '+ 100 Kg',
          value: 100
        }
      } else if (parseFloat(weight) > 250 && parseFloat(weight) <= 500) {
        objWeight = {
          name: '+ 250 Kg',
          value: 250
        }
      } else if (parseFloat(weight) > 500 && parseFloat(weight) <= 1000) {
        objWeight = {
          name: '+ 500 Kg',
          value: 500
        }
      } else if (parseFloat(weight) > 1000) {
        objWeight = {
          name: '+ 1000 Kg',
          value: 1000
        }
      }
      return objWeight
    },

    // response BE variabel gak seragam
    mixinGetFreightType(item, freightType, weightestimation) {
      let type = ''
      if (item && freightType) {
        if (
          (item.priceCode && item.priceCode.includes('FREFRE')) ||
          (item.price_code && item.price_code.includes('FREFRE')) ||
          (item.code_price && item.code_price.includes('FREFRE'))
        ) {
          const packingV1 = item.packaging_type ? item.packaging_type : ''
          const packingV2 = item.packagingType ? item.packagingType : ''
          if (freightType.includes('FCL')) {
            const containerV1 =
              item.container_type && item.container_size
                ? `(${item.container_size}' ${item.container_type} ${packingV1})`
                : ''
            const containerV2 =
              item.containerType && item.containerSize
                ? `(${item.containerSize}' ${item.containerType} ${packingV2})`
                : ''
            type = containerV1 || containerV2
          } else if (
            freightType.includes('LCL') ||
            freightType === 'SEABREAKBULK'
          ) {
            type = packingV1 || packingV2 ? `(${packingV1 || packingV2})` : ''
          } else if (freightType.includes('AIR')) {
            const range = item.price_range || item.priceRange
            if (range && range === 1) {
              type = '(< 45 Kg)'
            } else if (range && range > 1) {
              type = `(+ ${range} Kg)`
            } else {
              const data = this.mixinGetWeightRangeObj(weightestimation)
              type = data ? `(${data.name})` : null
            }
          }
        }
      }
      return type
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getters/prices.js